<template>
    <div class="wp">
        <div class="w-1200 pc-1">
            <div class="left">
                <p class="p1">按标准目录</p>
                <p v-for="(item,index) in deviceType" :key="index" class="p2 pointer" :class="{active:item.name==device.name}" @click="clickDevice(item)">{{item.name}}</p>
            </div>
            <div class="right">
                <el-carousel indicator-position="none" height="500px">
                        <el-carousel-item v-for="(item,index) in imgs" :key="index" @click.native="getDetail(item.id)">
                            <el-image style="width: 100%; height: 100%" :src="item.path" fit="contain">
                             <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                            </el-image>
                            <p class="img-title">{{item.title}}</p>
                        </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="w-1200 pc-2">
            <div class="title-more">
                <div class="t-m-blue"></div>
                <p class="t-m-t">产品中心</p>
            </div>
            <div class="box-bottom">
                <div v-for="(item,index) in productList" :key="index" class="item pointer" @click="getDetail(item.id)">
                    <el-row class="w-100 h-100" :gutter="20">
                        <el-col class="h-100" :span="4">
                            <el-image style="width: 100%; height: 100%" :src="item.fgpic" fit="contain">
                             <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                            </el-image>
                        </el-col>
                         <el-col class="h-100" :span="15">
                            <p class="p1">{{item.pname}}</p>
                            <p class="p2 p-lv-3">{{item.fgnr}}</p>
                            <p class="p3"><span style="color:#444444;padding-right:15px;">装备类别</span> {{item.ptype}} </p>
                         </el-col>
                         <el-col class="h-100" :span="5">
                            <p class="p1">{{item.factoryName}}</p>
                            <p class="p3">联系人：{{item.connPerson}}</p>
                            <p class="p3">联系电话：{{item.phone}}</p>
                            <el-button type="primary" style="background:linear-gradient(-90deg,rgba(242,174,56,1),rgba(255,149,0,1));border:0;" size="mini" icon="el-icon-edit-outline">留言资讯</el-button>
                        </el-col>
                    </el-row>
                </div>
                <z-page :pageObj="page1"></z-page>
            </div>
        </div>
    </div>
</template>
<script>
import ProductCenter from './ProductCenter.js';
export default ProductCenter;
</script>
<style lang="scss" scoped>
@import './ProductCenter.scss';
</style>